import {
    ExtrudeGeometry,
    Group, ShapeGeometry,
} from 'three';
import * as THREE from "three";

class TableTop extends Group {
    constructor(tabletopSize, tableHeight, tableTopOuterMaterial, tableTopInnerMaterial, radius) {
        super();
        let geometry = createTableTop(parseFloat(tabletopSize.width), parseFloat(tabletopSize.height), parseFloat(tabletopSize.depth), parseInt(radius));

        this.tableInnerPlane = new THREE.Mesh(geometry, [
            tableTopOuterMaterial, //top, bottom
            tableTopInnerMaterial, // sides
        ]);
        this.tableInnerPlane.position.y = tableHeight;
        this.tableInnerPlane.position.z = 0;
        this.tableInnerPlane.rotation.x = -Math.PI / 2;
        this.tableInnerPlane.receiveShadow = true;
        this.tableInnerPlane.castShadow = true;
        this.add(this.tableInnerPlane);

        function createTableTop(width, height, depth, radius = 1) {
            let x = -width / 2;
            let y = -depth / 2;

            let shape = new THREE.Shape();
            if (radius > 0) {
                shape.moveTo(x, y + radius);
                shape.lineTo(x, y + depth - radius);
                shape.quadraticCurveTo(x, y + depth, x + radius, y + depth);
                shape.lineTo(x + width - radius, y + depth);
                shape.quadraticCurveTo(x + width, y + depth, x + width, y + depth - radius);
                shape.lineTo(x + width, y + radius);
                shape.quadraticCurveTo(x + width, y, x + width - radius, y);
                shape.lineTo(x + radius, y);
                shape.quadraticCurveTo(x, y, x, y + radius);
            } else {
                shape.moveTo(x, y);
                shape.lineTo(x, y + depth);
                shape.lineTo(x + width, y + depth);
                shape.lineTo(x + width, y);
                shape.lineTo(x, y);
            }

            const extrudeSettings = {
                depth: -height,
                bevelEnabled: false,
                bevelSegments: 2,
                steps: 2,
                bevelSize: 1,
                bevelThickness: 1
            };
            return new ExtrudeGeometry(shape, extrudeSettings);
        }
    }

    updateHeight(height) {
        this.tableInnerPlane.position.y = height;
    }
}

export {TableTop};
